import { Component } from "react";
import { withRouter } from '../../common/with-router';
import {Card, Form, Button, Row, Col, Table} from "react-bootstrap";
import { FaPlus, FaRegEdit, FaSearch, FaTrash, FaEraser, FaLaptop} from "react-icons/fa";
import api from "../../services/api";
import { formataDataExibicao, localUso } from '../../common/utils';
import Paginacao from '../../common/pagination';
import AsyncSelect from 'react-select/async';
import { FiDownload, FiMapPin, FiUser, FiUsers } from "react-icons/fi";
import { LuBox } from "react-icons/lu";
import Swal from 'sweetalert2';

class Inventario extends Component {
    constructor(props) {
        super(props);

        this.state = {
            listRegistros: [],
            error: "",
            loading: true,
            page_numb: 1,
            numero_patrimonio: "",
            busca: "",
            tipo_equipamento_id: "",
            tipo_equipamento_nome: "",
            colaborador_id: "",
            colaborador_nome: "",
            local_uso: "",
            projeto_id: "",
            projeto_nome: "",
            estatisticas: null,
            loadingEstatisticas: true,
            exportando: false,
        };
    }

    componentDidMount() {
        this.consultaRegistro();
        this.carregarEstatisticas();
    }

    consultaRegistro = (page_numb = 1) => {
        this.setState({ loading: true });

        const params = new URLSearchParams();
        params.append('page', page_numb);

        if (this.state.numero_patrimonio) params.append('numero_patrimonio', this.state.numero_patrimonio);
        if (this.state.busca) params.append('especificacao', this.state.busca);
        if (this.state.tipo_equipamento_id) params.append('tipo_equipamento_id', this.state.tipo_equipamento_id);
        if (this.state.colaborador_id) params.append('colaborador_id', this.state.colaborador_id);
        if (this.state.local_uso) params.append('local_uso', this.state.local_uso);
        if (this.state.projeto_id) params.append('projeto_id', this.state.projeto_id);

        api.get(`/inventario/equipamentos/?${params.toString()}`)
            .then(response => {
                this.setState({
                    loading: false,
                    error: "",
                    listRegistros: response.data,
                    page_numb: page_numb
                });
            })
            .catch(error => {
                let erro_msg = 'Erro ao consultar inventário, tente novamente.';

                if (error.response?.status === 500) {
                    erro_msg = 'Servidor indisponível no momento';
                } else if (error.response?.status === 403) {
                    erro_msg = 'Você não tem permissão para acessar essa área';
                }

                this.setState({
                    loading: false,
                    error: erro_msg
                });
            });
    };

    carregarEstatisticas = () => {
        api.get('/inventario/estatisticas/')
            .then(response => {
                this.setState({
                    estatisticas: response.data,
                    loadingEstatisticas: false
                });
            })
            .catch(error => {
                console.error('Erro ao carregar estatísticas:', error);
                this.setState({ loadingEstatisticas: false });
            });
    };

    renderRows = () => {
        if ('results' in this.state.listRegistros && this.state.listRegistros.results.length > 0) {
            return this.state.listRegistros.results.map((item) =>
                <tr key={item.id}>
                    <td><strong>{item.numero_patrimonio}</strong></td>
                    <td><strong><span className="badge rounded-pill bg-light text-dark border">{item.dados_tipo_equipamento?.nome || '—'}</span></strong></td>
                    <td>{item.especificacao || '—'}</td>
                    <td><strong><FiUsers/>{item.dados_colaborador?.nome || '—'}</strong></td>
                    <td><FiMapPin/>{localUso[item.local_uso] || item.local_uso || '—'}</td>
                    <td>{item.data_entrega ? formataDataExibicao(item.data_entrega) : '—'}</td>
                    <td>{item.descricao || '—'}</td>
                    <td>{item.dados_projeto?.nome || '—'}</td>
                    <td className="text-end">
                        <Button variant="light" href={"/inventario/edit/" + item.id} size="sm">
                            <FaRegEdit /> 
                        </Button>
                    </td>
                    <td className="text-end">
                        <Button variant="danger" size="sm" onClick={() => this.handleDelete(item.id)}>
                            <FaTrash />
                        </Button>
                    </td>
                </tr>
            );
        }

        return (
            <tr>
                <td colSpan={9}>Nenhum equipamento encontrado</td>
            </tr>
        );
    };

    handleChange = (e) => {
        const { name, value } = e.target;
        this.setState({ [name]: value });
    };

    handleChangeTipoEquipamento = (selectedOption) => {
        this.setState({
            tipo_equipamento_id: selectedOption?.value || '',
            tipo_equipamento_nome: selectedOption?.label || '',
        });
    };

    handleChangeColaborador = (selectedOption) => {
        this.setState({
            colaborador_id: selectedOption?.value || '',
            colaborador_nome: selectedOption?.label || '',
        });
    };

    handleChangeProjeto = (selectedOption) => {
        this.setState({
            projeto_id: selectedOption?.value || '',
            projeto_nome: selectedOption?.label || '',
        });
    };

    onClickPagina = (num_page) => {
        this.consultaRegistro(num_page);
    };

    buscaRegistro = (e) => {
        e.preventDefault();
        this.consultaRegistro(1);
    };

    limparFiltros = () => {
        this.setState({
            numero_patrimonio: "",
            busca: "",
            tipo_equipamento_id: "",
            tipo_equipamento_nome: "",
            colaborador_id: "",
            colaborador_nome: "",
            local_uso: "",
            projeto_id: "",
            projeto_nome: "",
            page_numb: 1,
        }, () => {
            this.consultaRegistro(1);
        });
    };

    exportarExcel = () => {
        this.setState({ exportando: true });

        const params = new URLSearchParams();

        if (this.state.numero_patrimonio) params.append('numero_patrimonio', this.state.numero_patrimonio);
        if (this.state.busca) params.append('especificacao', this.state.busca);
        if (this.state.tipo_equipamento_id) params.append('tipo_equipamento_id', this.state.tipo_equipamento_id);
        if (this.state.colaborador_id) params.append('colaborador_id', this.state.colaborador_id);
        if (this.state.local_uso) params.append('local_uso', this.state.local_uso);
        if (this.state.projeto_id) params.append('projeto_id', this.state.projeto_id);

        api.get(`/inventario/exportar-excel/?${params.toString()}`, {responseType: 'blob'})
        .then(response => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            
            const agora = new Date();
            const dataHora = agora.toISOString().slice(0, 19).replace(/[:T]/g, '-');
            link.setAttribute('download', `inventario_${dataHora}.xlsx`);
            
            document.body.appendChild(link);
            link.click();
            link.remove();
            
            this.setState({ exportando: false });

            Swal.fire({
                icon: 'success',
                title: 'Exportado com sucesso!',
                text: 'O arquivo Excel foi baixado.',
                timer: 2000,
                showConfirmButton: false
            });
        })
        .catch(error => {
            console.error('Erro ao exportar:', error);
            this.setState({ exportando: false });
            
            Swal.fire({
                icon: 'error',
                title: 'Erro ao exportar',
                text: 'Ocorreu um problema ao gerar o arquivo Excel.'
            });
        });
    };

    handleDelete = (id) => {
        Swal.fire({
            title: 'Tem certeza?',
            text: "Essa ação não poderá ser desfeita!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Sim, excluir!',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (result.isConfirmed) {
                api.delete(`/inventario/equipamentos/${id}/`)
                    .then(response => {
                        Swal.fire(
                            'Excluído!',
                            'Equipamento foi excluído com sucesso.',
                            'success'
                        );
                        this.consultaRegistro(this.state.page_numb);
                    })
                    .catch(error => {
                        Swal.fire(
                            'Erro!',
                            'Ocorreu um problema ao excluir o equipamento.',
                            'error'
                        );
                    });
            }
        });
    };

    carregaTipoEquipamento = async (inputValue) => {
        try {
            const response = await api.get(`/inventario/tipos/?nome=${inputValue}`);
            const dados = response.data.results || response.data;
            return dados.map(tipo => ({ value: tipo.id, label: tipo.nome }));
        } catch (error) {
            console.error('Erro ao carregar tipos de equipamento:', error);
            return [];
        }
    };

    carregarUsuariosFuncionarios = async (inputValue) => {
        const q = inputValue ? `&nome=${encodeURIComponent(inputValue)}` : "";
        try {
            const response = await api.get(`/usuarios/?page=1&funcionario=True${q}`);
            const results = Array.isArray(response.data?.results) ? response.data.results : (Array.isArray(response.data) ? response.data : []);

            return results.map(u => {
                const first = (u.first_name || "").trim();
                const last = (u.last_name || "").trim();
                const email = (u.email || "").trim();
                const displayName = [first, last].filter(Boolean).join(" ").trim();
                let label = displayName && email ? `${displayName} (${email})` : (displayName || email);
                return { value: u.id, label };
            });
        } catch (error) {
            console.error('Erro ao carregar colaboradores:', error);
            return [];
        }
    };

    carregarProjetos = async (inputValue) => {
        const q = inputValue ? `nome=${encodeURIComponent(inputValue)}` : "";
        try {
            const response = await api.get(`/inventario/projetos/?${q}`);
            const dados = response.data.results || response.data;
            return dados.map(projeto => ({ value: projeto.id, label: projeto.nome }));
        } catch (error) {
            console.error('Erro ao carregar projetos:', error);
            return [];
        }
    };

    renderCardsEstatisticas = () => {
        const { estatisticas, loadingEstatisticas } = this.state;

        if (loadingEstatisticas) {
            return (
                <Row className="mb-4">
                    <Col>
                        <div className="text-center py-3">
                            <span className="spinner-border spinner-border-sm"></span> Carregando estatísticas...
                        </div>
                    </Col>
                </Row>
            );
        }

        if (!estatisticas) return null;

        const tipoComMaisEquipamentos = estatisticas.equipamentos_por_tipo?.[0];

        return (
            <Row className="mb-4">
                <Col md={3} sm={6} xs={12} className="mb-3">
                    <Card className="shadow-sm h-100">
                        <Card.Body className="d-flex align-items-center">
                            <div className="flex-grow-1">
                                <h6 className="text-muted mb-1" style={{ fontSize: '0.875rem' }}>Total de Itens</h6>
                                <h2 className="mb-0 fw-bold">{estatisticas.total_equipamentos}</h2>
                                <small className="text-muted">Equipamentos cadastrados</small>
                            </div>
                            <div className="ms-3">
                                <div className="bg-light rounded-circle p-3" style={{ width: 60, height: 60 }}>
                                    <LuBox size={24} className="text-success" /> 
                                </div>
                            </div>
                        </Card.Body>
                    </Card>
                </Col>

                <Col md={3} sm={6} xs={12} className="mb-3">
                    <Card className="shadow-sm h-100">
                        <Card.Body className="d-flex align-items-center">
                            <div className="flex-grow-1">
                                <h6 className="text-muted mb-1" style={{ fontSize: '0.875rem' }}>Colaboradores</h6>
                                <h2 className="mb-0 fw-bold">{estatisticas.colaboradores_com_equipamentos}</h2>
                                <small className="text-muted">Com equipamentos</small>
                            </div>
                            <div className="ms-3">
                                <div className="bg-light rounded-circle p-3" style={{ width: 60, height: 60 }}>
                                    <FiUsers size={24} className="text-success" />
                                </div>
                            </div>
                        </Card.Body>
                    </Card>
                </Col>

                <Col md={3} sm={6} xs={12} className="mb-3">
                    <Card className="shadow-sm h-100">
                        <Card.Body className="d-flex align-items-center">
                            <div className="flex-grow-1">
                                <h6 className="text-muted mb-1" style={{ fontSize: '0.875rem' }}>
                                    {tipoComMaisEquipamentos?.tipo_equipamento__nome || 'Principal'}
                                </h6>
                                <h2 className="mb-0 fw-bold">{tipoComMaisEquipamentos?.total || 0}</h2>
                                <small className="text-muted">Equipamentos principais</small>
                            </div>
                            <div className="ms-3">
                                <div className="bg-light rounded-circle p-3" style={{ width: 60, height: 60 }}>
                                    <FaLaptop size={24} className="text-success" />
                                </div>
                            </div>
                        </Card.Body>
                    </Card>
                </Col>

                <Col md={3} sm={6} xs={12} className="mb-3">
                    <Card className="shadow-sm h-100">
                        <Card.Body className="d-flex align-items-center">
                            <div className="flex-grow-1">
                                <h6 className="text-muted mb-1" style={{ fontSize: '0.875rem' }}>Localizações</h6>
                                <h2 className="mb-0 fw-bold">{estatisticas.localizacoes_diferentes}</h2>
                                <small className="text-muted">Diferentes locais</small>
                            </div>
                            <div className="ms-3">
                                <div className="bg-light rounded-circle p-3" style={{ width: 60, height: 60 }}>
                                    <FiMapPin size={24} className="text-success" />
                                </div>
                            </div>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        );
    };

    render() {
        const customStyles = {
            option: (provided) => ({ ...provided, fontSize: '13px' }),
            singleValue: (provided) => ({ ...provided, fontSize: '13px' }),
        };

        return (
            <div>
                <Row className="align-items-center">
                    <Col sm={6} lg={6}>
                        <h4 className="page-title">Inventários de Equipamentos</h4>
                    </Col>
                    <Col sm={6} lg={6} className="text-end">
                        <Button variant="secondary" href="/inventario/add" className="mb-3" size="sm">
                            <FaPlus /> Adicionar Inventário de Equipamento
                        </Button>
                    </Col>
                </Row>

                {/* Renderização card com estatisticas */}
                {this.renderCardsEstatisticas()}

                <Card className="cardDestaque">
                    <Card.Body>
                        <h4>Filtros</h4>
                        <Form method="get" onSubmit={this.buscaRegistro}>
                            <Row>
                                <Col sm={2} xs={12}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Número do Patrimônio</Form.Label>
                                        <Form.Control
                                            type="text"
                                            name="numero_patrimonio"
                                            value={this.state.numero_patrimonio}
                                            onChange={this.handleChange}
                                            placeholder="N° Patrimônio"
                                        />
                                    </Form.Group>
                                </Col>
                                <Col sm={2} xs={12}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Tipo de Equipamento</Form.Label>
                                        <AsyncSelect
                                            cacheOptions
                                            loadOptions={this.carregaTipoEquipamento}
                                            defaultOptions
                                            placeholder="Todos os Tipos"
                                            noOptionsMessage={() => "Nenhum tipo encontrado"}
                                            onChange={this.handleChangeTipoEquipamento}
                                            value={this.state.tipo_equipamento_id ? {value: this.state.tipo_equipamento_id, label: this.state.tipo_equipamento_nome} : null}
                                            isClearable
                                            styles={customStyles}
                                        />
                                    </Form.Group>
                                </Col>
                                <Col sm={2} xs={12}>
                                    <Form.Group className="mb-3">
                                        <Form.Label className="fw-semibold d-flex align-items-center gap-2">
                                            <FiUser className="text-muted" /> Colaborador
                                        </Form.Label>
                                        <AsyncSelect
                                            cacheOptions
                                            defaultOptions
                                            loadOptions={this.carregarUsuariosFuncionarios}
                                            placeholder="Todos os Colaboradores"
                                            noOptionsMessage={() => "Nenhum colaborador encontrado"}
                                            onChange={this.handleChangeColaborador}
                                            value={this.state.colaborador_id ? {value: this.state.colaborador_id, label: this.state.colaborador_nome} : null}
                                            isClearable
                                            styles={customStyles}
                                        />
                                    </Form.Group>
                                </Col>
                                <Col sm={2} xs={12}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Local de Uso</Form.Label>
                                        <Form.Control as="select" name="local_uso" value={this.state.local_uso} onChange={this.handleChange}>
                                            <option value="">Todos os Locais</option>
                                            {Object.entries(localUso).map(([chave, valor]) => (
                                                <option key={chave} value={chave}>{valor}</option>
                                            ))}
                                        </Form.Control>
                                    </Form.Group>
                                </Col>
                                <Col sm={2} xs={12}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Projeto</Form.Label>
                                        <AsyncSelect
                                            cacheOptions
                                            defaultOptions
                                            loadOptions={this.carregarProjetos}
                                            placeholder="Todos os Projetos"
                                            noOptionsMessage={() => "Nenhum projeto encontrado"}
                                            onChange={this.handleChangeProjeto}
                                            value={this.state.projeto_id ? {value: this.state.projeto_id, label: this.state.projeto_nome} : null}
                                            isClearable
                                            styles={customStyles}
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>

                            <div className="d-flex gap-2">
                                <Button type="submit" variant="secondary" size="sm">
                                    <FaSearch className="me-2" /> Filtrar
                                </Button>
                                <Button type="button" size="sm" variant="light" onClick={this.limparFiltros}>
                                    <FaEraser /> Limpar filtro
                                </Button>
                                <div className="ms-auto">

                                    <Button type="button" size="sm"  variant="success" onClick={this.exportarExcel} disabled={this.state.exportando}>
                                        {this.state.exportando ? (
                                            <>
                                                <span className="spinner-border spinner-border-sm me-2"></span>
                                                Exportando...
                                            </>
                                        ) : (
                                            <>
                                                <FiDownload className="me-2" /> Exportar Inventário
                                            </>
                                        )}
                                    </Button>
                                </div>

                            </div>
                        </Form>
                    </Card.Body>
                </Card>

                <Card className="cardDestaque">
                    <Card.Body className="pt-0">
                        <Table responsive className="custom-table">
                            <thead>
                                <tr>
                                    <th>N° Patrimônio</th>
                                    <th>Tipo</th>
                                    <th>Especificação do Equipamento</th>
                                    <th>Colaborador</th>
                                    <th>Local de Uso</th>
                                    <th>Data de Entrega</th>
                                    <th>OBS</th>
                                    <th>Projeto</th>
                                    <th></th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.state.loading ? (
                                    <tr>
                                        <td colSpan={9}>Carregando...</td>
                                    </tr>
                                ) : (
                                    this.state.error ? (
                                        <tr>
                                            <td colSpan={9}>{this.state.error}</td>
                                        </tr>
                                    ) : this.renderRows()
                                )}
                            </tbody>
                        </Table>
                        {
                            'results' in this.state.listRegistros && this.state.listRegistros.results.length > 0 &&
                            <Paginacao dados={this.state.listRegistros} loading={this.state.loading} page_numb={this.state.page_numb} _onClickPagina={this.onClickPagina} />
                        }
                    </Card.Body>
                </Card>
            </div>
        );
    }
}

export default withRouter(Inventario);